import { createAction, handleActions } from 'redux-actions'

const setFetching = createAction('SCREENS/INSIGHTS/SET_FETCHING')
const resetFetching = createAction('SCREENS/INSIGHTS/RESET_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [setFetching]: (state, action) => action.payload,
    [resetFetching]: () => defaultState,
  },
  defaultState,
)

export { setFetching, resetFetching, reducer }
